const breakpoints = [768, 992, 1170]
const theme = {
  mediaBreakpoints: breakpoints,
  breakpoints: breakpoints.map((width) => `${width / 16}em`), // theme expects ems
  //   space: [
  //     0, 6, 12, 18, 24, 30, 36
  //   ],
  fontSizes: [12, 13, 14, 16, 18, 20, 23, 27, 38, 48, 72, 80],
  content: {
    max: {
      width: '1170px'
    }
  },
  ease: {
    ease_in_sine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
    ease_out_sine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
    ease_in_out_sine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
    ease_in_quad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    ease_out_quad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    ease_in_out_quad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    ease_in_cubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    ease_out_cubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    ease_in_out_cubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    ease_in_quart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
    ease_out_quart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    ease_in_out_quart: 'cubic-bezier(0.77, 0, 0.175, 1)',
    ease_in_quint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    ease_out_quint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    ease_in_out_quint: 'cubic-bezier(0.86, 0, 0.07, 1)',
    ease_in_expo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
    ease_out_expo: 'cubic-bezier(0.19, 1, 0.22, 1)',
    ease_in_out_expo: 'cubic-bezier(1, 0, 0, 1)',
    ease_in_circ: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
    ease_out_circ: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    ease_in_out_circ: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
    ease_in_back: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
    ease_out_back: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    ease_in_out_back: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
  },

  weights: [400, 600],
  colors: {
    black: '#111',
    white: '#fff',
    white_op65: 'rgba(255, 255, 255, 0.65)',
    white_op30: 'rgba(255, 255, 255, 0.30)',
    white_op10: 'rgba(255, 255, 255, 0.10)',
    green: '#19C784',
    green_op30: 'rgba(25,199,132, 0.3)',
    orange: '#F8A933',
    yellow: '#FFCD26',
    lighter_blue: '#2D7599',
    red: '#CD2400',
    blue: '#1E4F67',
    blue_op20: 'rgba(30, 79, 103, 0.2)',
    blue_op65: 'rgba(30, 79, 103, 0.65)',
    blue_op40: 'rgba(30, 79, 103, 0.40)',
    blue_op30: 'rgba(30, 79, 103, 0.30)',
    blue_op15: 'rgba(30, 79, 103, 0.15)',
    blue_light: '#ECEFF1',
    blue_light_op70: 'rgba(236, 239, 241, 0.7)',
    blue_light_op50: 'rgba(236, 239, 241, 0.5)',
    blue_light_op30: 'rgba(236, 239, 241, 0.3)',
    blue_light_op20: 'rgba(236, 239, 241, 0.2)',
    blue_light_op10: 'rgba(236, 239, 241, 0.1)',
    blue_mid: '#E5EDF1',
    blue_mid_op10: 'rgba(229, 237, 241, 0.1)',
    blue_dark: '#0F2733',
    blue_classic: '#00ADEE',
    blue_classic_op70: 'rgba(0, 173, 238, 0.7)',
    grey: 'rgba(66, 76, 94, 1)',
    grey_op90: 'rgba(66, 76, 94, 0.9)',
    grey_op80: 'rgba(66, 76, 94, 0.8)',
    grey_op75: 'rgba(66, 76, 94, 0.75)',
    grey_op65: 'rgba(66, 76, 94, 0.65)',
    grey_op40: 'rgba(66, 76, 94, 0.4)',
    grey_op25: 'rgba(66, 76, 94, 0.25)',
    grey_op10: 'rgba(66, 76, 94, 0.1)',
    grey_op05: 'rgba(66, 76, 94, 0.05)',
    grey_op0: 'rgba(66, 76, 94, 0)',
    grey_light: 'rgba(154, 163, 179, 1)',
    grey_light_op65: 'rgba(154, 163, 179, 0.65)',
    grey_light_op30: 'rgba(154, 163, 179, 0.3)',
    grey_menu: '#50586A',
    grey_breadcrumbs: '#E6E2E7',
    grey_slate: '#5B6770',
    grey_lighter: '#E9E9EA',
    grey_mid: '#3B3C41',
    electric_blue: 'rgba(11, 110, 181, 1)',
    electric_blue_op50: 'rgba(11, 110, 181, 0.5)',
    electric_blue_op30: 'rgba(11, 110, 181, 0.3)',
    careers_blue: '#212C34',
    careers_midblue: '#2B4E65',
    careers_midblue12: 'rgba(43, 78, 101, 0.12)',
    careers_orange: '#D44E29'
  },
  font: '"FFMark", "-apple-system", "BlinkMacSystemFont","Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue", sans-serif',
  monospace: '"Roboto Mono", Menlo, monospace',
  // radius: {large:5, small:2},
  radius: 5
}

export default theme
